<template>
  <modal
    title="Tax Remittance"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div class="content">
      <div class="text">
        <p>
          The system automatically calculates individual PAYE per location and
          can help electronically remit to the relevant authorities.
        </p>
      </div>
      <div class="remittance-options">
        <div class="option">
          <label for="true" class="radio-label">
            <input
              type="radio"
              id="true"
              :value="true"
              v-model="setUpRemittance"
            />
            Yes, set me up for automatic remittance
            <span></span>
          </label>
        </div>
        <div class="option">
          <label for="false" class="radio-label">
            <input
              type="radio"
              id="false"
              :value="false"
              v-model="setUpRemittance"
            />
            No, don’t set me up
            <span></span>
          </label>
        </div>
      </div>
      <div class="button-wrapper">
        <p
          class="text-secondary-orange font-semibold cursor-pointer"
          @click="closeModal"
        >
          Close
        </p>
        <button class="button button-primary button-long">Save</button>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/UI/Modal/index";
export default {
  components: {
    Modal,
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      setUpRemittance: null,
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
.content {
  margin: 1rem 0;
}
.text p {
  font-size: 0.9rem;
  padding-bottom: 1.5rem;
}
.remittance-options {
  margin-bottom: 5rem;
}
.button-wrapper {
  margin: 2rem 0;
}
</style>
